import React, { forwardRef } from 'react';
import Countdown from 'react-countdown';
import { isBefore } from 'date-fns';
import { GradientButton } from '../GradientButton/index.js';
import styles from './index.module.scss.js';

const TimerButtonV2 = forwardRef(
  ({ enableAt, ...props }, forwardedRef) => {
    const formatNumber = (n) => n < 10 ? `0${n}` : n;
    if (!isBefore(/* @__PURE__ */ new Date(), enableAt || /* @__PURE__ */ new Date()))
      return /* @__PURE__ */ React.createElement(
        GradientButton,
        {
          animated: false,
          ...props,
          size: "md-2",
          ref: forwardedRef
        }
      );
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: styles.box,
        "aria-label": "timer button",
        type: "button",
        ref: forwardedRef
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, /* @__PURE__ */ React.createElement(
        Countdown,
        {
          date: enableAt,
          renderer: ({ days, hours, minutes, seconds }) => /* @__PURE__ */ React.createElement("div", null, days ? `${formatNumber(days)}: ` : "", formatNumber(hours), " : ", formatNumber(minutes), " :", " ", formatNumber(seconds))
        }
      ))
    );
  }
);
TimerButtonV2.displayName = "TimerButtonV2";

export { TimerButtonV2 };
//# sourceMappingURL=index.js.map
